// extracted by mini-css-extract-plugin
export default {"videoPopup":"CaHGqL0QAd","thumbnail":"x4sEhKYuPO","videoContent":"j8MPl3AWo3"};